import type { Cart } from '@src/domains/coupons/types/coupon';

export interface CartDiscount {
  fromCents: number;
  toCents: number;
  differenceCents: number;
  percentage: number;
}

export function computeCartDiscount(cart: Cart): CartDiscount {
  const fromCents = cart?.costPreview?.fullPartialAmountCents ?? 0;
  const toCents = cart?.costPreview?.totalAmountCents ?? 0;
  const differenceCents = fromCents - toCents;
  const percentage = (100 * differenceCents) / fromCents;

  return { fromCents, toCents, differenceCents, percentage };
}
